import { useQuery } from '@tanstack/react-query'
import { ApriorMapApi } from 'api/ApriorMapApi'
import { useUser } from 'hooks/user'
import { IApriorMap } from 'utils/interfaces'

const useAllApriorMaps = () => {
  const userId = useUser()?.state.id
  return useQuery<IApriorMap[], Error>({
    queryKey: ['aprior-maps', userId],
    queryFn: () => ApriorMapApi.getAll(),
    enabled: userId !== 0,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  })
}
export default useAllApriorMaps
